import * as React from 'react';

import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Checkbox from '@mui/material/Checkbox';
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import FormControl from '@mui/material/FormControl'
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select'

import { ValidateDate, ValidateDateRange } from '../utils/Validator.tsx';

export default function CharismaAssessmentDateForm(props){
       
    const [cError, setCError] = React.useState(0);    
    const [date, setDate] = React.useState(props.date);
    const [templateId, setTemplateId] = React.useState(props.templates.length > 0 ? props.templates[0].id : 0)
    const [error, setError] = React.useState(0);
    const [wait, setWait] = React.useState(false);

    function handleSubmit(){
                
        let lValid: number = ValidateDate(date);
        let lValidMin = 0;
        let lValidMax = 0;
        let lValidCourse = 0        
        if(lValid === 0 ){ 
            if(props.minDate !== undefined){           
                lValidMin = ValidateDateRange(props.minDate, date);
                if(lValidMin === 1){
                    setError(1);
                }
            }            
            if(props.maxDate !== undefined){           
                lValidMax = ValidateDateRange(date, props.maxDate);
                if(lValidMin === 1){
                    setError(2);
                }
            }           
        }            
                    
        else{
            setError(1);
        }
         
        if(lValid === 0 && lValidMax === 0 && lValidMin === 0 && lValidCourse === 0){            
            if(props.id === undefined){
                setWait(true);
                props.handleSubmit(date, templateId);
            }
            else{
                setWait(true);
                props.handleSubmit(date, props.id);
            }
        }
    }
    
    return(
        <Dialog
            open={true}
        >
            <DialogTitle>
                {props.title !== undefined ?
                    props.title
                    :
                    null
                }
            </DialogTitle>
            <DialogContent>
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="date"
                    label="Date"
                    name="date"
                    InputLabelProps={{ shrink: true, required: true }}
                    type={'date'}
                    error={error > 0}
                    helperText={error === 1 ? 'Date antérieure au début de la période' : error===2 ? 'Date postérieure à la fin de la période' : null}
                    value={date}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        setDate(event.target.value);
                    }}
                />                  
                {
                    props.type === 6 && props.id == undefined?
                        <FormControl fullWidth>
                            <InputLabel id="label">Modèle</InputLabel>
                            <Select
                                labelId="label"
                                id="type-select"                        
                                value={templateId}
                                label="Type de Formation"
                                onChange={(event)=>setTemplateId(event.target.value)}
                            >
                                {props.templates.map((template)=>(
                                    <MenuItem value={template.id}>{template.title}</MenuItem>
                                ))}
                            </Select>
                </FormControl>
                    :
                    null
                }        
                {wait ?
                    <Alert severity="info">{props.id === undefined ? "Création e cours" : "Modification en cours"}</Alert>
                    :
                    null
                }   
                {cError === 1 ?
                    <Alert severity="error">{"Aucun parcours sélectionné"}</Alert>
                    :
                    null
                }                   
            </DialogContent>
            <DialogActions>
                <Button disabled={wait} onClick={()=>handleSubmit()}>Valider</Button>
                <Button disabled={wait} onClick={()=>props.handleCancel()}>Annuler</Button>
            </DialogActions>
        </Dialog>        
    );
}